import { Button } from '@itau-loans-www/components'
import { useProposal } from '@itau-loans-www/hooks'
import { sdkAnalytics } from '@itau-loans-www/services'
import { isClient } from '@itau-loans-www/utils'

import './app-flux.scss'

const AppFlux = () => {
  const proposalContext = useProposal()

  const link = proposalContext?.product?.proposal?.link

  return (
    <div className="final_screen__content app-flux">
      <h1 className="final_screen__title">
        Já antecipou seu <br /> Saque-Aniversário FGTS?
      </h1>
      <p className="final_screen__text">
        Abra o app Itaú e antecipe até 7 <br /> saques do seu FGTS.
      </p>

      <div className="final_screen__buttons-wrapper">
        <Button
          fluid
          id="fgts-web-app-fallback"
          onClick={() => {
            if (isClient()) {
              sdkAnalytics.track('trackClick', 'btn:abrir-app-itau')
              window.open(link, '_blank')
            }
          }}
        >
          Abrir app Itaú
        </Button>
      </div>
    </div>
  )
}

export default AppFlux
